import {useBiobookPages} from '../hooks/useBiobookPages';

export const BiobookCount = () => {
  const {matchedBiobookPages} = useBiobookPages();

  return <>{matchedBiobookPages.length}</>;
};
